<template>
  <div :class="{'container-dark': theme_dark}">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">发布</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/添加.png" class="nav-img none" />
      </div>
    </div>

    <div class="block">
      <div class="infoma ub ub-pc">
        <img :src="user.photo" class="photo" />
        <span class="nick2">{{ user.nick }}</span>
      </div>

      <div class="ub ub-ver info-item">
          <input type="text" v-model="title" placeholder="标题(限16字)" />
          <textarea contenteditable="true"  v-model="content"  placeholder="内容(不低于20字)" class="describe-text"></textarea>
          <input type="text" v-model="wx" placeholder="微信或QQ号" />
          <div class="tips">
            微信或者QQ号是隐私信息，如果对方查看需要支付3000金币，同时你会获得3000积分（魅力值），可放心填写，不会受到骚扰。
          </div>
        </div>
     
      <div class="ub ub-ac ub-ver">
        <div class="tips">
          为了防止用户受到骚扰，发布寻人贴需支付100金币
        </div>
        <div class="ub ub-ac ub-pc submit-btn" @click="save()">发布</div>
      </div>
    </div>

    <alert ref="myConfirm_buyCoin" @userBehavior="formact_buycoin"></alert>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import Alert from "../../components/Alert.vue";
export default {
   components: {
     alert: Alert
  },
  data() {
    return {
      user: {
        photo: require("../../assets/img/头像.jpg"),
        nick: "***",
        coin_left: 0,
      },
      title: "",
      content: "",
      wx: "",
      theme_dark: false,
      click_tag: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo","act_sub_coin"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    init_page() {
      var uid = this.$store.state.uid;
      var self = this;

      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          //console.log(JSON.stringify(u));
          self.user.uid = u.uid;
          self.user.photo = u.photo;
          self.user.nick = u.nick;
          self.user.coin_left = u.coin_left;
          //console.log(self.user.coin_left);
        },
      });
    },
    save() {
      //处理连续点击问题
      if (this.click_tag) return;
      this.click_tag = true;

      var self = this;
      setTimeout(() => {
        self.click_tag = false;
      }, 5000);

      var title = this.title;
      var content = this.content;
      var wx = this.wx;
      //判断是否为空
      if (title == "") {
        this.$toast.center("标题不能为空哦");
        return false;
      }
       if (title.length < 10) {
        this.$toast.center("标题不能低于10个字符");
        return false;
      }
      if (title.length > 16) {
        this.$toast.center("标题不能超过16个字符");
        return false;
      }
      if (content == "") {
        this.$toast.center("内容不能为空哦");
        return false;
      }
      if (content.length < 20) {
        this.$toast.center("内容不能低于20字");
        return false;
      }
      if (wx == "") {
        this.$toast.center("微信或QQ号不能为空哦");
        return false;
      }

      //判断剩余金币
      if (this.user.coin_left < 100) {
        this.$refs.myConfirm_buyCoin.show("金币余额不足,请先充值哦", {
          type: "confirm",
          confirmText: "充值",
          titleText: "温馨提示",
          data: "",
        });
        return false;
      } 
      //扣除金币
      var uid = this.$store.state.uid;
      var data = {
        "uid":uid,
        "coin":100
      };
      this.sub_coin_relieve(data);
    },


    //收集信息发往后台
    dosave(){
      var uid = this.$store.state.uid;
      var title = this.title;
      var content = this.content;
      var wx = this.wx;
      var data_send = {
          "uid": uid,
          "title": title,
          "content": content,
          "wx": wx,
          "state": "通过",
        };
        var strsend = JSON.stringify(data_send);
        var self = this;
        this.post({
          url: "/App/Publish_seek_people",
          data: { uid: uid, data: strsend },
          success: function (serve_data) {
            //console.log(serve_data);
            self.$toast.center("发布成功");
            self.title = "";
            self.content = "";
            self.wx = "";

            var bll_id = serve_data.id || "";
            var msg = {
                  "txt": "寻人区审核",
                  "desc": "",
                  "id": bll_id
            }
            tool.send_check_msg(self,"check_seek_people",msg,true);

            self.back();
          },
        });
    },

    //扣除金币
    sub_coin_relieve(data) {
     
      var send_data = {
        "uid_from": data.uid,
        "uid_to": "",
        "amount": data.coin,
        "type_dtl": "发布寻人贴",
        "comment": "",
      };
      var self = this;
      self.act_sub_coin({
        uid: data.uid,
        strSend: JSON.stringify(send_data),
        success: function (res) {
          //console.log(JSON.stringify(res));
          if (res.state == "1") {
            self.dosave();
          }
        },
      });
    },

    formact_buycoin(type, data) {
      if (type == "clickConfirm") {
        this.$router.push({ name: "mycoin" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  padding: 0.8rem;
  background-color: #fff;
  .photo {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    margin-right: 0.7rem;
  }
  .nick2 {
    font-size: 1rem;
  }

  .info-item {
    input {
      padding: 0.6rem 0.5rem;
      background-color: transparent;
      border: 1px solid #a9d7f7;
      outline: 0;
      font-size: 0.95rem;
      border-radius: 0.3rem;
      margin-top: 0.8rem;
      color: #333;
    }
    input:focus {
      border-color: rgb(33, 164, 252);
    }
    .describe-text {
      height: 8rem;
      outline: 0;
      border-color: #a9d7f7;
      margin-top: 0.9rem;

      border-radius: 0.3rem;
      padding: 0.55rem 0.5rem;
      color: #333;
      font-size: 1rem;
      resize: none;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
    .describe-text:focus {
      border-color: rgb(33, 164, 252);
    }
  }

  .tips {
    font-size: 0.8rem;
    margin-top: 0.8rem;
    color: #ddd;
  }
  
  .submit-btn {
    width: 100%;
    height: 2.3rem;
    line-height: 2.3rem;
    border-radius: 1rem;
    background: linear-gradient( 90deg, #A264E7 0%, #FE9CC0 100%);
    color: #fff;
    margin-top: 0.8rem;
  }
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .block {
    background-color: #2c2b30;
    .infoma {
      .nick2 {
        color: #FDFDFD;
      }
    }
    .info-item {
      input {
        border: 1px solid #404040;
        color: #fff;
      }
      input:focus {
        border-color: #686767;
      }
      .describe-text {
        background-color: #2c2b30;
        border-color: #404040;
        color: #fff;
      }
      .describe-text:focus {
        border-color: #686767;
      }
    }
    .tips {
      color: #444;
    }
  }
}
</style>